/**
 * Function that takes in a number and returns it as a formatted percentage.
 * Note that the number is truncated and there are no decimal places kept.
 * @param percent The number to format as a percentage.
 * @param decimals The number of decimal places (default is 0 = truncate).
 * @returns The number formatted as a percentage string.
 */
export function formatPercent(percent: number, decimals = 0): string {
  return `${Math.abs(percent).toFixed(decimals)}%`;
}
